import React from 'react'
import {useParams} from 'react-router-dom'
import {Box} from '@salesforce/retail-react-app/app/components/shared/ui'
import PageLoader from '../../components/page-loader'
import {useServerContext} from '@salesforce/pwa-kit-react-sdk/ssr/universal/hooks'
import Optimizely from '../../components/optimizely'
import {MAX_CACHE_AGE_CMS, STALE_WHILE_REVALIDATE_M} from '../../constants'
import {useOptimizelyPage} from '../../hooks/use-optimizely-page'
import ContentNotFoundBanner from '../../components/optimizely/utils/contentNotFoundBanner'
// import PageNotFound from '../page-not-found' // TEMP: restore when all (brand, locale) trees are populated

const ContentPage = () => {
    const {res} = useServerContext()
    const {pageName} = useParams()

    if (res) {
        res.set(
            'Cache-Control',
            `s-maxage=${MAX_CACHE_AGE_CMS}, stale-while-revalidate=${STALE_WHILE_REVALIDATE_M}`
        )
    }

    // Remove .html from the page name to get the content key
    const contentKey = pageName?.replace('.html', '') || ''

    // Request content from Optimizely based on the page name
    const {data: optimizelyData, isLoading: isOptimizelyLoading} = useOptimizelyPage(contentKey)
    if (isOptimizelyLoading) {
        return (
            <Box data-testid="content-page">
                <PageLoader />
            </Box>
        )
    }

    // Check if CMS content exists - if not, show 404
    const pageContent = optimizelyData?.page || optimizelyData
    const hasContent = pageContent?.items?.length > 0 || pageContent?.Content?.items?.length > 0

    // Temporary: surface a banner with the missing (brand, locale) instead of
    // routing to PageNotFound while the per-locale content trees are being
    // populated. Restore `return <PageNotFound />` once all trees are authored.
    if (!hasContent) {
        return (
            <Box data-testid="content-page">
                <ContentNotFoundBanner contentKey={contentKey} />
            </Box>
        )
    }

    // SEO is now handled by the Optimizely component using CMS page data
    // (MetaTitle, MetaDescription, CanonicalUrl, OpenGraphTags, ExcludeFromSitemap)
    return (
        <Box data-testid="content-page">
            <Optimizely content={pageContent} isLoading={isOptimizelyLoading} />
        </Box>
    )
}

export default ContentPage
